import { render, staticRenderFns } from "./FactorToggle.vue?vue&type=template&id=5dd1f18e&scoped=true&"
import script from "./FactorToggle.vue?vue&type=script&lang=ts&"
export * from "./FactorToggle.vue?vue&type=script&lang=ts&"
import style0 from "./FactorToggle.vue?vue&type=style&index=0&id=5dd1f18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd1f18e",
  null
  
)

export default component.exports